import { render, staticRenderFns } from "./AnnuityDetailList.vue?vue&type=template&id=1ffe065c&"
import script from "./AnnuityDetailList.vue?vue&type=script&lang=js&"
export * from "./AnnuityDetailList.vue?vue&type=script&lang=js&"
import style0 from "./AnnuityDetailList.vue?vue&type=style&index=0&id=1ffe065c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports